import { render, staticRenderFns } from "./DatasetTabLineage.vue?vue&type=template&id=aac91acc&scoped=true&lang=pug"
import script from "./DatasetTabLineage.vue?vue&type=script&lang=js"
export * from "./DatasetTabLineage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac91acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac91acc')) {
      api.createRecord('aac91acc', component.options)
    } else {
      api.reload('aac91acc', component.options)
    }
    module.hot.accept("./DatasetTabLineage.vue?vue&type=template&id=aac91acc&scoped=true&lang=pug", function () {
      api.rerender('aac91acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/DatasetTabLineage.vue"
export default component.exports